import { FC, useEffect } from "react";
import Modal from "../../Modal";
import ModalContent from "../../Modal/ModalContent";
import styles from "./Select.module.scss";
import ModalCloseButton from "@components/ui/ModalCloseButton";
import { IWallet, useWallet } from "@stores/wallet.store";
import { shortWallet } from "@utils/shortWallet";
import WalletButton from "@components/ui/wallet-button";
import cn from "classnames";
import { createModalHelpers } from "@stores/unified-modal.store";

interface Props {
    isVisible: boolean;
    setIsVisible(isVisible: boolean): void;
}

import { useLocation } from "react-router-dom";

const WalletSelect: FC<Props> = ({ isVisible, setIsVisible }) => {
    const location = useLocation();
    const externalWallet = useWallet((state) => state.externalWallet);
    const wallets = useWallet((state) => state.wallets);
    const currentWallet = useWallet((state) => state.currentWallet);
    const setCurrentWallet = useWallet((state) => state.setCurrentWallet);
    const getWallets = useWallet((state) => state.getWallets);
    const fetchReferrals = useWallet((state) => state.fetchReferrals);

    // Fetch wallets when modal becomes visible
    useEffect(() => {
        if (isVisible) {
            fetchReferrals();
            getWallets();
        }
    }, [isVisible, getWallets]);

    const handleChooseWallet = (wallet: IWallet) => {
        setCurrentWallet(wallet);
        setIsVisible(false);
    };

    const { openModal } = createModalHelpers();

    return (
        <Modal isVisible={isVisible} setIsVisible={setIsVisible}>
            <ModalContent classNames={cn()}>
                <div className="flex items-center justify-between">
                    <h2 className="text-xl font-medium">Connected wallets </h2>
                    <ModalCloseButton className={styles.close} onClick={() => setIsVisible(false)} />
                </div>

                {externalWallet && externalWallet.friendlyAddress && (
                    <WalletButton
                        onClick={() => handleChooseWallet(externalWallet)}
                        text={shortWallet(externalWallet.friendlyAddress)}
                        active={currentWallet && externalWallet.guid === currentWallet.guid}
                        disabled={location.pathname === "/sniper"}
                    />
                )}
                {wallets.map(
                    (wallet) =>
                        wallet.isMnemonics &&
                        wallet.friendlyAddress && (
                            <WalletButton
                                key={wallet.guid}
                                onClick={() => handleChooseWallet(wallet)}
                                text={shortWallet(wallet.friendlyAddress)}
                                internal
                                active={currentWallet && wallet.guid === currentWallet.guid}
                            />
                        ),
                )}
                {wallets.length === 0 && (
                    <p className={cn("text-sm text-foreground/50 border border-muted-foreground rounded-xl p-4")}>
                        Create a new wallet for sniper and fast trades. Use your current wallet for swaps.
                    </p>
                )}
                <div className={cn("flex items-center justify-between gap-2")}>
                    <WalletButton text={"Create wallet"} newWallet onClick={() => openModal("create")} internal />
                    <WalletButton text={"Import wallet"} newWallet onClick={() => openModal("import")} />
                </div>
            </ModalContent>
        </Modal>
    );
};

export default WalletSelect;
